import { render, staticRenderFns } from "./vertical_navbar.vue?vue&type=template&id=16757bfa&"
import script from "./vertical_navbar.vue?vue&type=script&lang=js&"
export * from "./vertical_navbar.vue?vue&type=script&lang=js&"
import style0 from "./vertical_navbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports